import React, { useState } from "react";
import "./App.css";
import { useForm } from "react-hook-form";
import axios from "axios";
const url = "/api/calculate";

function App() {
    const [fees, setFees] = useState("");
    const { register, handleSubmit } = useForm();
    const onSubmit = async (data) => {
        console.log(data);
        const response = await axios.post(url, {
            price: data.price,
            category: data.category,
        });
        console.log(response);
        setFees(response.data);
    };
    return (
        <div className="parent">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                    <label id="priceLabel">Price:</label>
                    <input
                        className="inputPrice"
                        type="number"
                        placeholder="price"
                        name="price"
                        {...register("price")}
                    />
                </div>

                <div className="form-group2">
                    <label id="categoryLabel" htmlFor="category ">
                        Category:
                    </label>

                    <select
                        className="inputCategory "
                        id="category"
                        name="category"
                        {...register("category")}
                    >
                        <option value="mobile">mobile</option>
                        <option value="laptop">laptop</option>
                    </select>
                </div>

                <input className="submit" type="submit" />
            </form>
            <div className="output ">
                <p> {fees} </p>
            </div>
        </div>
    );
}

export default App;
